import React from "react";
import "../Health/HealthBanner.css";
import { motion } from "framer-motion";
import bgImage from "../../Assets/foundation/Trust.png";

const TrustBanner = () => {
  return (
    <section className="health-banner">
      {/* Animated Background Image Reveal */}
      <motion.img
        src={bgImage}
        alt="Background"
        className="bg-image"
        initial={{ scale: 1.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      />

      <div className="banner-content">
        {/* Left content reveal */}
        <motion.div
          className="left-content"
          initial={{ x: -80, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.div
            className="text-box"
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 1, ease: "easeOut" }}
          >
            <h2>
              Uplifting Humankind with <br />
              <motion.span
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7, duration: 1 }}
              >
                Purpose and Compassion.
              </motion.span>
            </h2>
            <p>
              VCNR Foundation is the heart of our purpose. From rural development and wellness
              to education and sustainability, we create real change that uplifts humanity and
              empowers humankind.
            </p>

            <motion.button
              className="explore-btn1"
              onClick={() => window.open("https://www.hithachinthana.org", "_blank")}
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ delay: 1, duration: 0.8 }}
            >
              Explore More
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustBanner;
